<template>
  <div style="height: 100%">
    <!-- 自定义告警内容 -->
    <el-row>
      <el-col :lg="3" :md="4" :sm="5" :xl="3" :xs="5" class="form-row-span">
        自定义告警内容：
      </el-col>
      <el-col :lg="20" :md="19" :offset="1" :sm="18" :xl="18" :xs="18">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入自定义告警内容"
          v-model="form.alarmContent"
          style="width: 100%">
        </el-input>
      </el-col>
    </el-row>

    <!-- 时间范围 -->
    <el-row class="margin-top-20">
      <el-col :lg="3" :md="4" :sm="5" :xl="3" :xs="5" class="form-row-span">
        时间范围：
      </el-col>
      <el-col :lg="20" :md="19" :offset="1" :sm="18" :xl="18" :xs="18">
        <el-input-number
          v-model="form.timeRange"
          :min="1"
          :max="999"
          size="mini"
          style="width: 120px;">
        </el-input-number>
        <span style="margin-left: 10px;">秒</span>
      </el-col>
    </el-row>

    <!-- 持续时间 -->
    <el-row class="margin-top-20">
      <el-col :lg="3" :md="4" :sm="5" :xl="3" :xs="5" class="form-row-span">
        持续时间：
      </el-col>
      <el-col :lg="20" :md="19" :offset="1" :sm="18" :xl="18" :xs="18">
        <el-input-number
          v-model="form.duration"
          :min="1"
          :max="999"
          size="mini"
          style="width: 120px;">
        </el-input-number>
        <span style="margin-left: 10px;">秒</span>
      </el-col>
    </el-row>

    <!-- 空间、设备、测点选择 -->
    <el-row class="margin-top-20">
      <el-col :lg="3" :md="4" :sm="5" :xl="3" :xs="5" class="form-row-span">
        测点：
      </el-col>
      <el-col :lg="20" :md="19" :offset="1" :sm="18" :xl="18" :xs="18">
        <div v-for="(item, index) in form.alarmConvergenceSettingDetails" :key="item.id || 'new-'+index" style="margin-bottom: 10px; display: flex; align-items: center;">
          <el-cascader
            :options="spaceTree"
            :props="spaceCascaderProps"
            @change="(val) => changeSpace(val, index)"
            clearable
            placeholder="请选择空间"
            size="mini"
            style="width: 20%"
            v-model="item.spaceIdPath">
          </el-cascader>
          
          <el-select
            @change="(val) => changeDevice(val, index)"
            placeholder="请选择设备"
            size="mini"
            style="width: 20%; margin-left: 10px;"
            v-model="item.deviceId">
            <el-option
              :key="device.id"
              :label="device.name"
              :value="device.id"
              v-for="device in item.deviceList">
            </el-option>
          </el-select>
          
          <el-select
            placeholder="可选择测点"
            size="mini"
            style="width: 20%; margin-left: 10px;"
            v-model="item.pointId">
            <el-option
              :key="point.id"
              :label="point.name"
              :value="point.id"
              v-for="point in item.pointList">
            </el-option>
          </el-select>
          
          <el-button 
            type="danger" 
            size="mini" 
            icon="el-icon-delete" 
            @click="deleteSettingDetail(index)" 
            style="margin-left: 10px;"
            v-if="form.alarmConvergenceSettingDetails.length > 1">
          </el-button>
          
          <el-button 
            type="primary" 
            size="mini" 
            icon="el-icon-plus" 
            @click="addSettingDetail" 
            style="margin-left: 10px;"
            v-if="index === form.alarmConvergenceSettingDetails.length - 1">
          </el-button>
        </div>
      </el-col>
    </el-row>

    <!-- 作用目标：空间、设备（可多组，对接 alarmConvergenceSettingTargets） -->
    <el-row class="margin-top-20">
      <el-col :lg="3" :md="4" :sm="5" :xl="3" :xs="5" class="form-row-span">
        作用目标：
      </el-col>
      <el-col :lg="20" :md="19" :offset="1" :sm="18" :xl="18" :xs="18">
        <div
          v-for="(target, tIndex) in form.alarmConvergenceSettingTargets"
          :key="target.id || 'tgt-' + tIndex"
          style="margin-bottom: 10px; display: flex; align-items: center; flex-wrap: wrap;">
          <el-cascader
            :key="'tgt-cas-' + tIndex + '-' + (target.id || 'n') + '-' + targetSpacePathKey(target)"
            :options="spaceTree"
            :props="spaceCascaderProps"
            @change="(val) => changeTargetSpace(val, tIndex)"
            clearable
            placeholder="请选择空间"
            size="mini"
            style="width: 20%"
            v-model="target.spaceIdPath">
          </el-cascader>

          <el-select
            :key="'tgt-dev-' + tIndex + '-' + (target.id || 'n') + '-' + (target.deviceId === undefined || target.deviceId === null ? 'x' : target.deviceId)"
            @change="(val) => changeTargetDevice(val, tIndex)"
            placeholder="请选择设备"
            size="mini"
            style="width: 20%; margin-left: 10px;"
            v-model="target.deviceId">
            <el-option
              :key="device.id"
              :label="device.name"
              :value="device.id"
              v-for="device in target.deviceList">
            </el-option>
          </el-select>

          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="deleteTargetRow(tIndex)"
            style="margin-left: 10px;"
            v-if="form.alarmConvergenceSettingTargets.length > 1">
          </el-button>

          <el-button
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="addTargetRow"
            style="margin-left: 10px;"
            v-if="tIndex === form.alarmConvergenceSettingTargets.length - 1">
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getDeviceCategoryList} from "@/network/device-category";
import {getBySpaceIdAndTypId} from "@/network/device-info";
import {listByDeviceId} from "@/network/device-measuring-point";

export default {
  name: "UpgradeStrategy",
  data() {
    return {
      formReady: false,
      categoryList: [],
      spaceCascaderProps: {
        expandTrigger: 'click',
        checkStrictly: true,
        emitPath: true,
        value: 'value',
        label: 'label',
        children: 'children'
      },
      form: {
        alarmContent: '', // 自定义告警内容
        timeRange: 60, // 时间范围，改为数字类型，默认60分钟
        duration: 5, // 持续时间，默认5分钟
        alarmConvergenceSettingDetails: [{ // 空间-设备-测点组
          spaceIdPath: '', // 级联选择器的值
          spaceId: '', // API需要的空间ID
          spaceName: null,
          deviceId: '',
          deviceName: '',
          pointId: '',
          pointName: '',
          deviceList: [], // UI操作需要的列表
          pointList: [] // UI操作需要的列表
        }],
        alarmConvergenceSettingTargets: [{ // 作用目标：空间-设备（无测点）
          spaceIdPath: '',
          spaceId: '',
          spaceName: null,
          deviceId: '',
          deviceName: '',
          snCode: '',
          deviceList: []
        }]
      }
    }
  },
  props: ["spaceTree", "strategyData", "accountList"],
  watch: {
    form: {
      handler(newV) {
        if (!this.formReady) return;
        // 转换为API需要的格式
        const submitData = {
          id: this.strategyData?.id,
          alarmContent: newV.alarmContent,
          timeRange: newV.timeRange,
          duration: newV.duration,
          // 处理alarmConvergenceSettingDetails，移除UI专用字段
          alarmConvergenceSettingDetails: newV.alarmConvergenceSettingDetails
            .filter(item => {
              const hasSpace = this.isDefinedId(item.spaceId) || (Array.isArray(item.spaceIdPath) && item.spaceIdPath.length > 0);
              return hasSpace && this.isDefinedId(item.deviceId) && this.isDefinedId(item.pointId);
            })
            .map(item => {
              const pointInfo = item.pointList.find(p => String(p.id) === String(item.pointId)) || {};
              const deviceInfo = item.deviceList.find(d => String(d.id) === String(item.deviceId)) || {};
              
              return {
                id: item.id,
                settingId: this.strategyData?.id,
                spaceId: Array.isArray(item.spaceIdPath) ? item.spaceIdPath[item.spaceIdPath.length - 1] : item.spaceId,
                spaceName: item.spaceName,
                deviceId: item.deviceId,
                deviceName: deviceInfo.name || item.deviceName,
                pointId: item.pointId,
                pointName: pointInfo.name || item.pointName
              };
            }),
          alarmConvergenceSettingTargets: (newV.alarmConvergenceSettingTargets || [])
            .filter(t => {
              const hasSpace = this.isDefinedId(t.spaceId) || (Array.isArray(t.spaceIdPath) && t.spaceIdPath.length > 0);
              return hasSpace && this.isDefinedId(t.deviceId);
            })
            .map(t => {
              const deviceInfo = t.deviceList.find(d => String(d.id) === String(t.deviceId)) || {};
              return {
                id: t.id,
                settingId: this.strategyData?.id,
                spaceId: Array.isArray(t.spaceIdPath) ? t.spaceIdPath[t.spaceIdPath.length - 1] : t.spaceId,
                spaceName: t.spaceName,
                deviceId: t.deviceId,
                deviceName: deviceInfo.name || t.deviceName,
                snCode: t.snCode || ''
              };
            }),
          // 添加空的告警升级动作列表，防止undefined错误
          alarmUpgradeActionList: this.strategyData?.alarmUpgradeActionList || []
        };
        
        console.log('提交数据转换完成，设置项数量:', submitData.alarmConvergenceSettingDetails.length);
        this.$emit('receiveData', submitData);
      },
      deep: true
    },
    /**
     * 只随「策略 id」变化做全量 init。若对 strategyData 做 deep watch，
     * 子组件 form 每次同步到父组件 receiveData 都会改 prop，init 会反复执行，
     * 设备/测点接口会被打成倍请求。
     */
    'strategyData.id': {
      handler() {
        const id = this.strategyData ? this.strategyData.id : undefined;
        console.log('strategyData.id 变更:', id);
        if (this.isDefinedId(id)) {
          this.init();
        } else {
          this.formReady = false;
          this.form = {
            alarmContent: '',
            timeRange: 60,
            duration: 5,
            alarmConvergenceSettingDetails: [{
              spaceIdPath: '',
              spaceId: '',
              spaceName: null,
              deviceId: '',
              deviceName: '',
              pointId: '',
              pointName: '',
              deviceList: [],
              pointList: []
            }],
            alarmConvergenceSettingTargets: [{
              spaceIdPath: '',
              spaceId: '',
              spaceName: null,
              deviceId: '',
              deviceName: '',
              snCode: '',
              deviceList: []
            }]
          };
          this.$nextTick(() => {
            this.formReady = true;
          });
        }
      },
      immediate: true
    },
    spaceTree: {
      handler() {
        if (this.isPlaceholderSpaceTree(this.spaceTree)) return;
        this.$nextTick(() => this.applySpacePathsFromTree());
      },
      deep: true
    }
  },
  created() {
    this.getDeviceCategoryList();
  },
  methods: {
    defaultTargetRow() {
      return {
        spaceIdPath: '',
        spaceId: '',
        spaceName: null,
        deviceId: '',
        deviceName: '',
        snCode: '',
        deviceList: []
      };
    },
    /** 接口可能返回 0；不能用 if (id) 判断，否则作用目标不会拉设备列表 */
    isDefinedId(v) {
      return v !== undefined && v !== null && v !== '';
    },
    /** 列表接口若把 targets 挂在 detail 下，兼容读法 */
    resolveRawTargetsFromStrategy() {
      const src = this.strategyData;
      if (!src) return [];
      const top = src.alarmConvergenceSettingTargets || src.alarm_convergence_setting_targets;
      if (Array.isArray(top) && top.length > 0) {
        return top.slice();
      }
      const out = [];
      const details = src.alarmConvergenceSettingDetails;
      if (Array.isArray(details)) {
        details.forEach((d) => {
          if (Array.isArray(d.alarmConvergenceSettingTargets) && d.alarmConvergenceSettingTargets.length) {
            out.push(...d.alarmConvergenceSettingTargets);
          }
        });
      }
      return out;
    },
    targetSpacePathKey(target) {
      const p = target.spaceIdPath;
      return Array.isArray(p) && p.length ? p.join('_') : 'empty';
    },
    /** 父组件初始占位树或未加载完成时，级联无法匹配路径，编辑回显会空白 */
    isPlaceholderSpaceTree(tree) {
      if (!tree || tree.length === 0) return true;
      if ( tree.length === 1) {
        const n = tree[0];
        if (n && String(n.value) === '' && (n.label === '' || n.label === undefined)) return true;
      }
      return false;
    },
    /**
     * 级联展示依赖 path 与 options 各层 node.value 严格一致；fallback [spaceId] 若类型与树不一致会只显示数字 id
     */
    normalizeSpacePathForCascader(spaceId) {
      if (!this.isDefinedId(spaceId)) return [];
      if (!this.spaceTree || this.isPlaceholderSpaceTree(this.spaceTree)) {
        const p = this.findSpaceIdPath(spaceId);
        return p && p.length ? p.slice() : [spaceId];
      }
      const raw = this.findSpaceIdPath(spaceId);
      if (!raw || raw.length === 0) return [spaceId];
      const out = [];
      let level = this.spaceTree;
      for (let i = 0; i < raw.length; i++) {
        if (!level || !level.length) break;
        const node = level.find(n => String(n.value) === String(raw[i]));
        if (!node) break;
        out.push(node.value);
        level = node.children;
      }
      if (out.length === 0) return raw.slice();
      if (String(out[out.length - 1]) !== String(spaceId)) {
        return raw.slice();
      }
      return out;
    },
    applySpacePathsFromTree() {
      if (this.isPlaceholderSpaceTree(this.spaceTree)) return;
      const sync = (row) => {
        if (!this.isDefinedId(row.spaceId)) return;
        const path = this.normalizeSpacePathForCascader(row.spaceId);
        if (!path || path.length === 0) return;
        this.$set(row, 'spaceIdPath', path.slice());
        this.$set(row, 'spaceId', path[path.length - 1]);
      };
      (this.form.alarmConvergenceSettingDetails || []).forEach(sync);
      (this.form.alarmConvergenceSettingTargets || []).forEach(sync);
    },
    scheduleApplySpacePathsWhenTreeReady() {
      this.$nextTick(() => {
        if (!this.isPlaceholderSpaceTree(this.spaceTree)) {
          this.applySpacePathsFromTree();
        }
      });
    },
    //初始化
    init() {
      this.formReady = false;
      if (this.strategyData && this.strategyData.alarmConvergenceSettingDetails && this.strategyData.alarmConvergenceSettingDetails.length > 0) {
        // 直接使用传入的数据而不是尝试合并或重组数据
        const settingDetails = [];
        
        console.log('初始化告警聚合设置，原始记录数:', this.strategyData.alarmConvergenceSettingDetails.length);
        
        // 保留每条记录的唯一性，即使空间和设备相同
        this.strategyData.alarmConvergenceSettingDetails.forEach((detail, idx) => {
          console.log(`处理第${idx+1}条记录:`, JSON.stringify({
            id: detail.id,
            spaceId: detail.spaceId,
            deviceId: detail.deviceId,
            pointId: detail.pointId
          }));
          
          let spaceIdPath;
          try {
            spaceIdPath = this.normalizeSpacePathForCascader(detail.spaceId);
            if (!spaceIdPath || spaceIdPath.length === 0) {
              spaceIdPath = this.isDefinedId(detail.spaceId) ? [detail.spaceId] : [];
            }
          } catch (e) {
            console.error('查找空间路径出错:', e);
            spaceIdPath = this.isDefinedId(detail.spaceId) ? [detail.spaceId] : [];
          }
          const leafSpace = spaceIdPath.length ? spaceIdPath[spaceIdPath.length - 1] : detail.spaceId;
          
          const setting = {
            id: detail.id, // 保留原始ID很重要
            spaceId: leafSpace,
            spaceName: detail.spaceName,
            deviceId: detail.deviceId,
            deviceName: detail.deviceName,
            pointId: detail.pointId,
            pointName: detail.pointName,
            spaceIdPath: spaceIdPath,
            deviceList: [],
            pointList: [],
            settingId: detail.settingId
          };
          
          settingDetails.push(setting);
        });
        
        const settingTargets = [];
        const rawTargets = this.resolveRawTargetsFromStrategy();
        if (rawTargets.length > 0) {
          rawTargets.forEach((t) => {
            let spaceIdPath;
            try {
              spaceIdPath = this.normalizeSpacePathForCascader(t.spaceId);
              if (!spaceIdPath || spaceIdPath.length === 0) {
                spaceIdPath = this.isDefinedId(t.spaceId) ? [t.spaceId] : [];
              }
            } catch (e) {
              console.error('查找作用目标空间路径出错:', e);
              spaceIdPath = this.isDefinedId(t.spaceId) ? [t.spaceId] : [];
            }
            const leafSpace = spaceIdPath.length ? spaceIdPath[spaceIdPath.length - 1] : t.spaceId;
            settingTargets.push({
              id: t.id,
              spaceId: leafSpace,
              spaceName: t.spaceName,
              deviceId: t.deviceId,
              deviceName: t.deviceName,
              snCode: t.snCode || '',
              spaceIdPath,
              deviceList: [],
              settingId: t.settingId
            });
          });
        } else {
          settingTargets.push(this.defaultTargetRow());
        }

        // 设置form数据，保持settingDetails的原始顺序和数量
        this.form = {
          id: this.strategyData.id,
          alarmContent: this.strategyData.alarmContent || '',
          timeRange: this.strategyData.timeRange || 60,
          duration: this.strategyData.duration || 5,
          alarmConvergenceSettingDetails: settingDetails,
          alarmConvergenceSettingTargets: settingTargets
        };
        
        // 异步加载每个记录的设备和测点列表
        settingDetails.forEach((item, index) => {
          this.getDeviceAndPointLists(item.spaceId, item.deviceId, index);
        });
        settingTargets.forEach((item, index) => {
          if (this.isDefinedId(item.spaceId)) {
            this.getTargetDevice(item.spaceId, index);
          }
        });
        
        console.log('表单数据构建完成，最终设置项数量:', this.form.alarmConvergenceSettingDetails.length);
      } else {
        // 兼容旧数据或初始化新表单
        const compatTargets = [];
        const rawTgts = this.resolveRawTargetsFromStrategy();
        if (rawTgts.length > 0) {
          rawTgts.forEach((t) => {
            let spaceIdPath;
            try {
              spaceIdPath = this.normalizeSpacePathForCascader(t.spaceId);
              if (!spaceIdPath || spaceIdPath.length === 0) {
                spaceIdPath = this.isDefinedId(t.spaceId) ? [t.spaceId] : [];
              }
            } catch (e) {
              spaceIdPath = this.isDefinedId(t.spaceId) ? [t.spaceId] : [];
            }
            const leafSpace = spaceIdPath.length ? spaceIdPath[spaceIdPath.length - 1] : t.spaceId;
            compatTargets.push({
              id: t.id,
              spaceId: leafSpace,
              spaceName: t.spaceName,
              deviceId: t.deviceId,
              deviceName: t.deviceName,
              snCode: t.snCode || '',
              spaceIdPath,
              deviceList: [],
              settingId: t.settingId
            });
          });
        } else {
          compatTargets.push(this.defaultTargetRow());
        }

        this.form = {
          alarmContent: this.strategyData?.alarmContent || '',
          timeRange: this.strategyData?.timeRange || 60,
          duration: this.strategyData?.duration || 5,
          alarmConvergenceSettingDetails: [{
            spaceIdPath: this.strategyData?.spaceId ? [this.strategyData.spaceId] : '',
            spaceId: this.strategyData?.spaceId || '',
            spaceName: null,
            deviceId: this.strategyData?.deviceId || '',
            deviceName: '',
            pointId: this.strategyData?.devicePoint || '',
            pointName: '',
            deviceList: [],
            pointList: []
          }],
          alarmConvergenceSettingTargets: compatTargets
        };
        
        // 如果有设备ID，获取测点列表
        if (this.isDefinedId(this.form.alarmConvergenceSettingDetails[0].deviceId)) {
          this.getDeviceAndPointLists(
            this.form.alarmConvergenceSettingDetails[0].spaceId, 
            this.form.alarmConvergenceSettingDetails[0].deviceId, 
            0
          );
        }
        compatTargets.forEach((item, index) => {
          if (this.isDefinedId(item.spaceId)) {
            this.getTargetDevice(item.spaceId, index);
          }
        });
      }
      this.$nextTick(() => {
        this.scheduleApplySpacePathsWhenTreeReady();
        this.$nextTick(() => {
          this.formReady = true;
        });
      });
    },
    // 获取设备和测点列表
    getDeviceAndPointLists(spaceId, deviceId, index) {
      // 获取设备列表
      this.getDevice(spaceId, null, index);
      
      // 获取测点列表
      if (this.isDefinedId(deviceId)) {
        this.getPoint(deviceId, index);
      }
    },
    //获取设备类型列表
    getDeviceCategoryList() {
      this.categoryList = [];
      getDeviceCategoryList().then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.categoryList = res.data;
          }
        }
      })
    },
    // 添加设备组
    addSettingDetail() {
      this.form.alarmConvergenceSettingDetails.push({
        spaceIdPath: '',
        spaceId: '',
        spaceName: null,
        deviceId: '',
        deviceName: '',
        pointId: '',
        pointName: '',
        deviceList: [],
        pointList: []
      });
    },
    // 删除设备组
    deleteSettingDetail(index) {
      this.form.alarmConvergenceSettingDetails.splice(index, 1);
    },
    addTargetRow() {
      this.form.alarmConvergenceSettingTargets.push(this.defaultTargetRow());
    },
    deleteTargetRow(index) {
      this.form.alarmConvergenceSettingTargets.splice(index, 1);
    },
    changeTargetSpace(val, index) {
      const row = this.form.alarmConvergenceSettingTargets[index];
      if (!row) return;
      if (val && val.length > 0) {
        const spaceId = val[val.length - 1];
        const prevLeaf = this.isDefinedId(row.spaceId) ? String(row.spaceId) : '';
        const nextLeaf = String(spaceId);
        row.spaceId = spaceId;
        this.findSpaceName(spaceId, row);
        // 空间变更后设备必须联动清空（与「测点」行一致）
        if (prevLeaf !== nextLeaf) {
          row.deviceId = '';
          row.deviceName = '';
          row.snCode = '';
          row.deviceList = [];
        }
        this.getTargetDevice(spaceId, index);
      } else {
        row.spaceId = '';
        row.spaceName = null;
        row.deviceId = '';
        row.deviceName = '';
        row.snCode = '';
        row.deviceList = [];
      }
    },
    changeTargetDevice(id, index) {
      const row = this.form.alarmConvergenceSettingTargets[index];
      if (!row) return;
      if (id) {
        const device = row.deviceList.find(d => String(d.id) === String(id));
        if (device) {
          row.deviceName = device.name;
          const sn = device.snCode != null && device.snCode !== ''
            ? device.snCode
            : (device.sn_code != null && device.sn_code !== '' ? device.sn_code : '');
          row.snCode = sn !== '' && sn != null ? String(sn) : '';
        }
      } else {
        row.deviceName = '';
        row.snCode = '';
      }
    },
    getTargetDevice(spaceId, index) {
      if (!this.isDefinedId(spaceId)) {
        return;
      }
      getBySpaceIdAndTypId(spaceId, null).then(res => {
        if (res.code !== 0) return;
        const rows = this.form.alarmConvergenceSettingTargets;
        if (index < 0 || index >= rows.length) return;
        const apiList = Array.isArray(res.data) ? res.data : [];
        rows[index].deviceList = apiList;
        const deviceId = rows[index].deviceId;
        if (!this.isDefinedId(deviceId)) return;
        const matched = apiList.find(d => String(d.id) === String(deviceId));
        if (matched) {
          this.$set(rows[index], 'deviceId', matched.id);
          return;
        }
        if (this.strategyData?.id) {
          const row = rows[index];
          let label = row.deviceName && String(row.deviceName).trim()
            ? String(row.deviceName).trim()
            : '';
          if (row.snCode && String(row.snCode).trim()) {
            const sn = String(row.snCode).trim();
            label = label ? `${label} (${sn})` : sn;
          }
          if (!label) label = `设备(${deviceId})`;
          const nextList = [{ id: deviceId, name: label }, ...apiList];
          this.$set(rows[index], 'deviceList', nextList);
          this.$set(rows[index], 'deviceId', deviceId);
          return;
        }
        rows[index].deviceId = '';
        rows[index].deviceName = '';
      }).catch(err => {
        console.error('获取作用目标设备列表出错:', err);
      });
    },
    //空间选择
    changeSpace(val, index) {
      const row = this.form.alarmConvergenceSettingDetails[index];
      if (!row) return;
      if (val && val.length > 0) {
        const spaceId = val[val.length - 1];
        const prevLeaf = this.isDefinedId(row.spaceId) ? String(row.spaceId) : '';
        const nextLeaf = String(spaceId);
        row.spaceId = spaceId;
        this.findSpaceName(spaceId, row);
        // 空间变更后设备、测点必须联动清空
        if (prevLeaf !== nextLeaf) {
          row.deviceId = '';
          row.deviceName = '';
          row.pointId = '';
          row.pointName = '';
          row.deviceList = [];
          row.pointList = [];
        }
        this.getDevice(spaceId, null, index);
      } else {
        row.spaceId = '';
        row.spaceName = null;
        row.deviceId = '';
        row.deviceName = '';
        row.pointId = '';
        row.pointName = '';
        row.deviceList = [];
        row.pointList = [];
      }
    },
    // 查找并设置空间名称
    findSpaceName(id, item) {
      const findNameInTree = (nodes, targetId) => {
        for (const node of nodes) {
          if (String(node.value) === String(targetId)) {
            return node.label;
          }
          if (node.children && node.children.length > 0) {
            const name = findNameInTree(node.children, targetId);
            if (name) return name;
          }
        }
        return null;
      };
      
      item.spaceName = findNameInTree(this.spaceTree, id) || null;
    },
    //设备选择
    changeDevice(id, index) {
      const row = this.form.alarmConvergenceSettingDetails[index];
      if (!row) return;
      // 设备变更后测点必须联动清空（@change 时 v-model 已是新设备）
      row.pointId = '';
      row.pointName = '';
      row.pointList = [];
      if (id) {
        const device = row.deviceList.find(d => String(d.id) === String(id));
        if (device) {
          row.deviceName = device.name;
        }
      } else {
        row.deviceName = '';
      }
      this.getPoint(id, index);
    },
    //根据空间获取设备列表
    getDevice(spaceId, categoryId, index) {
      if (!spaceId) {
        console.log(`空间ID为空，跳过获取设备列表, index=${index}`);
        return;
      }
      
      console.log(`获取设备列表，空间ID=${spaceId}, index=${index}`);
      
      getBySpaceIdAndTypId(spaceId, categoryId).then(res => {
        if (res.code === 0) {
          // 确保索引仍然有效
          if (index >= 0 && index < this.form.alarmConvergenceSettingDetails.length) {
            this.form.alarmConvergenceSettingDetails[index].deviceList = res.data;
            
            // 如果有预设的设备ID，保留它
            const deviceId = this.form.alarmConvergenceSettingDetails[index].deviceId;
            if (deviceId) {
              console.log(`保留预设设备ID: ${deviceId}, index=${index}`);
              // 如果设备列表中有此设备，则保留设备ID
              const hasDevice = res.data.some(d => String(d.id) === String(deviceId));
              if (hasDevice) {
                // 获取测点列表
                this.getPoint(deviceId, index);
              } else {
                console.log(`设备ID ${deviceId} 在设备列表中不存在, index=${index}`);
                // 如果设备ID不在列表中，可能需要清空设备ID和测点列表
                if (!this.strategyData?.id) {
                  this.form.alarmConvergenceSettingDetails[index].deviceId = '';
                  this.form.alarmConvergenceSettingDetails[index].pointList = [];
                  this.form.alarmConvergenceSettingDetails[index].pointId = '';
                }
              }
            }
          } else {
            console.error(`设备列表返回，但索引无效: ${index}`);
          }
        }
      }).catch(err => {
        console.error(`获取设备列表出错:`, err);
      });
    },
    
    //获取测点列表
    getPoint(deviceId, index) {
      if (!deviceId) {
        console.log(`设备ID为空，跳过获取测点列表, index=${index}`);
        return;
      }
      
      console.log(`获取测点列表，设备ID=${deviceId}, index=${index}`);
      
      listByDeviceId(deviceId).then(res => {
        if (res.code === 0) {
          // 确保索引仍然有效
          if (index >= 0 && index < this.form.alarmConvergenceSettingDetails.length) {
            this.form.alarmConvergenceSettingDetails[index].pointList = res.data;
            
            // 如果有预设的测点ID，保留它
            const pointId = this.form.alarmConvergenceSettingDetails[index].pointId;
            if (pointId) {
              console.log(`保留预设测点ID: ${pointId}, index=${index}`);
              // 设置点名称
              const point = res.data.find(p => String(p.id) === String(pointId));
              if (point) {
                this.form.alarmConvergenceSettingDetails[index].pointName = point.name;
                console.log(`找到测点名称: ${point.name}, index=${index}`);
              } else {
                console.log(`测点ID ${pointId} 在测点列表中不存在, index=${index}`);
                // 如果测点ID不在列表中，可能需要清空测点ID
                if (!this.strategyData?.id) {
                  this.form.alarmConvergenceSettingDetails[index].pointId = '';
                }
              }
            }
          } else {
            console.error(`测点列表返回，但索引无效: ${index}`);
          }
        }
      }).catch(err => {
        console.error(`获取测点列表出错:`, err);
      });
    },
    // 改进的查找空间ID完整路径的方法
    findSpaceIdPath(targetId) {
      if (!targetId) return [];
      
      // 将目标ID转为字符串，以便比较
      const targetIdStr = String(targetId);
      
      // 递归查找空间ID的完整路径
      const findPath = (nodes, id, path = []) => {
        for (const node of nodes) {
          // 将节点值转为字符串进行比较
          const nodeValue = String(node.value);
          
          // 当前节点匹配
          if (nodeValue === id) {
            return [...path, node.value];
          }
          
          // 检查子节点
          if (node.children && node.children.length > 0) {
            const foundPath = findPath(node.children, id, [...path, node.value]);
            if (foundPath) return foundPath;
          }
        }
        return null;
      };
      
      const path = findPath(this.spaceTree, targetIdStr);
      
      // 如果找不到路径，直接返回ID作为单元素数组
      if (!path) {
        console.log('未找到空间路径，使用原始ID:', targetId);
        return [targetId]; 
      }
      
      console.log('找到空间路径:', path);
      return path;
    }
  }
}
</script>

<style scoped>
.margin-top-20 {
  margin-top: 20px;
}
::v-deep(.el-input-number__decrease){
  background: rgba(41, 155, 255, 0.4);
  border-right: 1px solid rgba(41, 155, 255, 0.4);
  color: #fff;
}
::v-deep(.el-input-number__increase){
  background: rgba(41, 155, 255, 0.4);
  border-left: 1px solid rgba(41, 155, 255, 0.4);
  color: #fff;
}

</style>
